<template>
  <material-card
:title="$t('globals.contacts')"
    :color="$vuetify.theme.themes.light.secondary"
    icon="email"
  >
    <v-card-text>
      <pbas-data-table
        ref="table"
        :showSelect="false"
        :dataProvider="provider"
        :rowActions="rowActions"
        :floatActions="floatActions"
        fileNamePrefix="contacts"
        @itemsChanged="setData($event)"
        :identifier="identifier"
        @error="error = $event"
      ></pbas-data-table>
    </v-card-text>
    <v-dialog scrollable v-model="deleteDialog" persistent max-width="400">
      <material-card
        v-if="editedItem"
        :title="
          $t('components.contacts.delete_contact_{0}', [
            editedItem.Email,
          ])
        "
        :color="$vuetify.theme.themes.light.error"
        icon="delete"
      >
        <v-card-text>
          {{ $t("globals.are_you_sure") }}
        </v-card-text>
        <v-card-actions>
          <v-btn color text @click="deleteDialog = false">
            {{ $t("globals.cancel") }}
          </v-btn>
          <v-btn color="error" text @click="tryDelete">
            {{ $t("globals.delete") }}
          </v-btn>
        </v-card-actions>
      </material-card>
    </v-dialog>
    <v-dialog scrollable v-model="editDialog" persistent max-width="500px">
      <material-card
        v-if="editedItem !== null && editedItem !== undefined"
        :title="formTitle"
        :icon="formIcon"
        :color="formColor"
      >
        <v-card-text>
          <v-form ref="form" v-model="valid">
            <v-container fluid fill-height>
              <v-flex md12>
                <trans-select
                  :clearable="true"
                  :item="editedItem"
                  propertyName="Title"
                  :items="options.Models.Title"
                  :label="$t('headers.members_management.Title')"
                ></trans-select>
                <no-autocomplete-textfield
                  v-model="editedItem.Name"
                  :label="$t('globals.name')"
                  required
                  :rules="[$rules.required]"
                  class="required"
                ></no-autocomplete-textfield>
                <no-autocomplete-textfield
                  v-model="editedItem.Email"
                  :label="$t('headers.contacts.email')"
                  required
                  :rules="[$rules.required, $rules.email]"
                  class="required"
                ></no-autocomplete-textfield>
                <no-autocomplete-textfield
                  v-model="editedItem.PhoneNumber"
                  :label="$t('headers.locals.phone_number')"
                  required
                  :rules="[rules.phone]"
                  v-mask="telephoneMask"
                ></no-autocomplete-textfield>
                <no-autocomplete-textfield
                  v-model="editedItem.Fax"
                  :label="$t('globals.fax_number')"
                  required
                  :rules="[rules.phone]"
                  v-mask="telephoneMask"
                ></no-autocomplete-textfield>
                <v-checkbox
                  v-model="editedItem.IsPrincipal"
                  :label="$t('components.plancreationwizard.primary')"
                ></v-checkbox>
              </v-flex>
            </v-container>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-btn text @click="close">{{ $t("globals.cancel") }}</v-btn>
          <v-btn :disabled="!valid" color="primary" @click="save">
            {{ $t("globals.save") }}
          </v-btn>
        </v-card-actions>
      </material-card>
    </v-dialog>
    <error-handler :error="error"></error-handler>
  </material-card>
</template>

<script>
import { mapGetters } from "vuex";
import { InMemoryProvider } from "pbas-vue-components";
import InMemoryContactsPlanCreationHeaders from "@/headers/InMemoryContactsPlanCreation";
import ErrorHandler from "@/components/ErrorHandler";
import NoAutocompleteTextfield from "@/components/NoAutocompleteTextfield";
import { tokens, mask } from "vue-the-mask";
import masker from "vue-the-mask/src/masker";
import TransSelect from "@/components/TransSelect";

export default {
  components: {
    ErrorHandler,
    NoAutocompleteTextfield,
    TransSelect,
  },
  props: ["contacts", "identifier", "planIdentityId", "disabled"],
  directives: { mask },
  data() {
    return {
      error: null,
      items: [],
      insuranceCarriers: [],
      confirmDeactivateDialog: false,
      confirmActivateDialog: false,
      deleteDialog: false,
      provider: undefined,
      trustFunds: [],
      floatActions: [
        {
          name: "addItem",
          icon: "add",
          color: this.$vuetify.theme.themes.light.success,
          text: "globals.add_new",
          handler: () => {
            let item = {
              Name: "",
              Email: "",
              IsInHouse: false,
              Identifier: Math.random().toString(),
            };
            this.isNew = true;
            this.editItem(item);
          },
          visible: () => !this.disabled,
        },
      ],
      rowActions: [
        {
          name: "edit",
          icon: "edit",
          title: "globals.edit",
          handler: (item) => {
            this.isNew = false;
            this.editItem(item);
          },
          visible: () => !this.disabled,
        },
        {
          name: "delete",
          icon: "delete",
          title: "globals.delete",
          handler: (item) => {
            this.editedItem = item;
            this.deleteDialog = true;
          },
          visible: () => !this.disabled,
        },
      ],
      e6: 1,
      editDialog: false,
      valid: true,
      headers: [],
      editedItem: null,
      isNew: false,
      rules: {
        phone: (v) => {
          let val = this.unmask(v, this.telephoneMask);
          return !val || this.$rules.phone(val);
        },
      },
      telephoneMask: "(###) ### - ####",
    };
  },
  computed: {
    ...mapGetters("common", ["language"]),
    ...mapGetters("plansMembers", ["options"]),
    formTitle() {
      return this.isNew
        ? this.$t("components.contacts.create_new_contact")
        : this.$t("components.contacts.edit_contact_{0}", [
            this.editedItem.Email,
          ]);
    },
    formIcon() {
      return this.isNew ? "add" : "edit";
    },
    formColor() {
      return this.isNew ? this.$vuetify.theme.themes.light.success : this.$vuetify.theme.themes.light.primary;
    },
  },
  watch: {
    contacts: {
      handler(v) {
        if (v) {
          if (this.provider) {
            this.provider.items = v;
            this.$refs.table.getDataAsync();
          }
        }
      },
    },
  },
  mounted() {
    this.loadPlanData();
  },
  methods: {
    unmask(v, mask) {
      if (v) {
        return masker(v, mask, false, tokens);
      }
      return v;
    },
    translate(item) {
      let trans = item.Translations.filter(
        (o) => o.LanguageCode === this.language.language
      );
      return trans.length > 0
        ? trans[0].DisplayValue
        : this.language.language + "-" + item.Name;
    },
    reload() {
      this.$refs.table.getDataAsync();
    },
    setData(items) {
      this.items = items;
    },
    async loadPlanData() {
      try {
        this.headers = [].concat.apply([], InMemoryContactsPlanCreationHeaders);
        this.provider = new InMemoryProvider(this.contacts, this.headers);
      } catch (error) {
        this.error = error;
      }
    },
    validate() {
      if (this.$refs.form && this.$refs.form.validate()) {
        return true;
      }
      return false;
    },
    async editItem(item) {
      this.editedItem = JSON.parse(JSON.stringify(item));
      this.editDialog = true;
    },
    close() {
      this.editDialog = false;
      this.editedItem = null;
      this.$refs.form.resetValidation();
    },
    save() {
      this.editedItem.PlanIdentityId = this.planIdentityId;
      if (this.isNew) {
        this.add();
      } else {
        this.update();
      }
    },
    async update() {
      const con = this.provider.items.filter(
        (o) => o.Identifier === this.editedItem.Identifier
      )[0];
      const index = this.provider.items.indexOf(con);
      this.provider.items[index] = JSON.parse(JSON.stringify(this.editedItem));
      this.close();
      this.$refs.table.getDataAsync();
      this.$emit("contacts-changed", this.provider.items);
    },
    async add() {
      this.provider.items.push(JSON.parse(JSON.stringify(this.editedItem)));
      this.close();
      this.$refs.table.getDataAsync();
      this.$emit("contacts-changed", this.provider.items);
    },
    async tryDelete() {
      const con = this.provider.items.filter(
        (o) => o.Identifier === this.editedItem.Identifier
      )[0];
      const index = this.provider.items.indexOf(con);
      this.provider.items.splice(index, 1);
      this.deleteDialog = false;
      this.$refs.table.getDataAsync();
      this.$emit("contacts-changed", this.provider.items);
    },
  },
};
</script>
